import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
export function useFocusOptionController(_ref) {
  var length = _ref.length,
    _ref$minIndex = _ref.minIndex,
    minIndex = _ref$minIndex === void 0 ? 0 : _ref$minIndex;
  var _React$useState = React.useState(-1),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusedIndex = _React$useState2[0],
    setFocusedIndex = _React$useState2[1];
  var moveFocus = function moveFocus(delta) {
    var nextIndex = focusedIndex + delta;
    if (nextIndex < minIndex || nextIndex >= length) {
      return;
    }
    setFocusedIndex(nextIndex);
  };
  return {
    focusedIndex: focusedIndex,
    actions: {
      moveFocus: moveFocus,
      setFocusedIndex: setFocusedIndex
    }
  };
}